/**
 * 用于存储app的各种全局状态,如:
 * > 当前是否正在进行路由切换(以用于显示一个加载的效果)
 * > 下一个页面切换的方向(用以实现页面切换动画)
 * > 列表页面的滚动条位置等
 */
import {ROUTE_SWITCHING} from '../mutation-types'

const state = {
  isSwitching: false,   // 路由正在切换...
  priceReportTabIndex: 1,
  userReportTabIndex: 2,
  priceReportAwardTabIndex: 3,
  priceReportNotAwardTabIndex: 4,
  tLTermIndex: 1,
  promoteSaleTabIndex: 1,
  festivalAwardTabIndex: 1
}

const mutations = {
  [ROUTE_SWITCHING] (state, isSwitching) {
    state.isSwitching = isSwitching
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js